// routes/_authenticated/index.tsx — root of the authenticated area. Redirects
// / -> /dashboard so the URL bar matches the visible page on first paint.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
